import React, { PropsWithChildren, ReactElement } from "react"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { InputText, InputTextProps } from "@silversea-ssc/ui-components-react"
import InputWithError from "./InputWithError"

type Props<T extends FieldValues> = {
    register: ReturnType<UseFormReturn<T>["register"]>
    label: string
    type?: InputTextProps["type"]
    disabled: InputTextProps["disabled"]
    autoComplete: InputTextProps["autoComplete"]
}

export function InputTextWithError<T extends FieldValues>({
    register,
    label,
    type = "text",
    disabled = false,
    autoComplete,
}: PropsWithChildren<Props<T>>): ReactElement {
    return (
        <InputWithError name={register.name} label={label}>
            <InputText {...register} disabled={disabled} type={type} autoComplete={autoComplete} />
        </InputWithError>
    )
}
